<app-vital-flag-fixed-target (closeEmmiter)="closeDialog($event)"></app-vital-flag-fixed-target>
